export enum OAuthType {
  google = 0,
  microsoft = 1
}

export type OAuthCodeParams = {
  code: string;
  type: OAuthType;
};

export default class OAuthCredential {
  token?: string;
  access_token: string;
  expires_in: number;
  token_type: 'Bearer';
  refresh_token: string;
  revokedSessions?: {
    authorizationDate: string;
    ipAddress: string;
  }[];
  readonly scope = 'mbs_provider_api offline_access';
}
